<div class="viewport viewport-full viewport-center bg-secondary">
  <div class="content">
    <h1>{{ 'RESPONSE.SUCCESS.title' | translate }}</h1>
    <h2>{{ 'RESPONSE.SUCCESS.description' | translate }}</h2>
  </div>
  <div class="logo-wrapper">
    <img ngSrc="/images/logo_w_text_white.png" alt="Famulus Logo with text" priority fill>
  </div>
</div>
